import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VerzekerdeComponent } from './verzekerde/verzekerde.component';
import { AdviesComponent } from './advies/advies.component';
import { BevestigingComponent } from './bevestiging/bevestiging.component';

const appRoutes: Routes = [
    { path: 'verzekerde', component: VerzekerdeComponent },
    { path: 'advies', component: AdviesComponent },
    { path: 'bevestiging', component: BevestigingComponent },
    { path: '*', redirectTo: 'verzekerde', pathMatch: 'full' },
    { path: '**', redirectTo: 'verzekerde', pathMatch: 'full' }
];
@NgModule({
    imports: [
        RouterModule.forRoot(appRoutes)
    ],
    exports: [
        RouterModule
    ]
})
export class AppRoutingModule { }
